import { WidgetContainer } from '../../infrastructure/widgets/WidgetContainer';
import { useAnnouncements } from './hooks/useAnnouncements';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';

export const announcementsConfig: WidgetConfig = {
  id: 'dash-announcements',
  title: 'Announcements',
  category: 'list',
  refreshStrategy: 'onFocus',
  defaultSize: { w: 4, h: 4 },
  priority: 3,
};

export function AnnouncementsWidget() {
  const { data, isLoading, isError, error, refetch } = useAnnouncements();

  const announcements = data?.slice(0, 5) || [];

  return (
    <WidgetContainer
      config={announcementsConfig}
      isLoading={isLoading}
      isError={isError}
      errorMessage={error?.message}
      onRefresh={() => { refetch(); }}
    >
      <div className="flex flex-col gap-2">
        {announcements.length > 0 ? (
          announcements.map((announcement) => (
            <div
              key={announcement.id}
              className="flex flex-col gap-1 rounded-card-sm border border-outline bg-surface p-3"
            >
              <div className="flex justify-between items-start gap-2">
                <p className="text-data-md font-semibold text-primary">
                  {announcement.title}
                </p>
                <span className="whitespace-nowrap text-body-sm text-on-surface-variant">
                  {new Date(announcement.created_at).toLocaleDateString()}
                </span>
              </div>
              <p className="line-clamp-2 text-body-sm text-on-surface">
                {announcement.body}
              </p>
            </div>
          ))
        ) : (
          <p className="text-body-sm text-on-surface-variant italic p-4 text-center">
            No recent announcements.
          </p>
        )}
      </div>
    </WidgetContainer>
  );
}
